import { List } from 'immutable';
import { accountingDocConstants } from 'constants/accounting_doc.constants';

export function accounting_docs(state = {}, action) {
  switch (action.type) {
    case accountingDocConstants.ACCOUNTING_DOC_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case accountingDocConstants.ACCOUNTING_DOC_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case accountingDocConstants.ACCOUNTING_DOC_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };

    default:
      return state;
  }
}
